import Packaging from "./packaging";

export default Packaging;